var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manager-deadline-root"},[(!_vm.deadline)?_c('div',{staticClass:"text-gray-500"},[_vm._v("–")]):(_vm.isOverdue)?_c('OurTag',{attrs:{"size":"md","color":"red","text":_vm.overdueLabel}}):_c('div',{staticClass:"manager-deadline tabular-nums"},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }